// extracted by mini-css-extract-plugin
export default {"chevron-right-icon":"styles-module__chevron-right-icon___59d489","chevronRightIcon":"styles-module__chevron-right-icon___59d489"};